module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/dm-dc3455775ad035d0926ce4551bc721a6.svg";